<template>
  <div class="intros-for-app-list">
    <v-data-table
      :headers="headers"
      :items="versionModules"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-spacer/>
          <v-dialog @click:outside="cancel" v-model="newDialog">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on" @click="newIntroBtn">New Introduction</v-btn>
            </template>

            <v-card>
              <v-card-title>
                <v-card-actions class="d-flex justify-space-between full-width">
                  <span class="headline" v-if="!edit">Add new Introduction</span>
                  <span class="headline" v-if="edit">Edit Introduction</span>
                  <v-btn fab depressed small color="grey" @click="cancel"><v-icon class="close"></v-icon></v-btn>
                </v-card-actions>
              </v-card-title>
              <v-card-text>
                <v-text-field outlined v-model="introTitle" label="Title"></v-text-field>
                <v-text-field outlined v-model="introLocation" label="Location"></v-text-field>
                <v-checkbox v-model="introActive" label="Active"></v-checkbox>
                <!-- Slides from API-->
                <v-card v-for="(slide, key) in editedIntroSlides" v-bind:key="key" v-if="edit" color="#f2f2f2" class="intros-app-slider mb-6">
                  <v-container class="app-slide">
                    <v-row>
                      <v-col>
                        <v-card-title>Page {{ key+1 }}</v-card-title>
                      </v-col>
                      <v-col class="d-flex justify-end">
                        <v-icon @click="deleteSlide(key)" class="delete text--darken-1 red--text"></v-icon>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col sm="8">
                        <v-text-field outlined background-color="#ffffff" label="Title:" v-model="slide.title"></v-text-field>
                        <v-textarea outlined background-color="#ffffff" label="Description" v-model="slide.description"></v-textarea>
                      </v-col>
                      <v-col sm="4">
                        <ImageComponent v-if="slide.image" :iri="slide.image" />
                        <v-file-input outlined background-color="#ffffff" accept="image/*" label="Image" @change="slideImageChanged($event, key)"></v-file-input>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
                <!-- New slides-->
                <v-card v-for="(newSlide, key) in newSlides" v-bind:key="`ns-${key}`" color="#f2f2f2" class="intros-app-slider mb-6">
                  <v-container class="app-slide">
                    <v-row>
                      <v-col>
                        <v-card-title>Page {{ editedIntroSlides.length + key + 1 }}</v-card-title>
                      </v-col>
                      <v-col class="d-flex justify-end">
                        <v-icon @click="deleteNewSlide(key)" class="delete text--darken-1 red--text"></v-icon>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-text-field outlined background-color="#ffffff" label="Title:" v-model="newSlide.title"></v-text-field>
                        <v-textarea outlined background-color="#ffffff" label="Description" v-model="newSlide.description"></v-textarea>
                      </v-col>
                      <v-col>
                        <v-file-input outlined background-color="#ffffff" accept="image/*" label="Image" :value="newSlideFiles[key]" @change="newSlideImageChanged($event, key)"></v-file-input>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
                <v-btn text outlined depressed @click="addNewSlide">+ Add page</v-btn>
              </v-card-text>

              <v-card-actions class="d-flex justify-end">
                <v-btn color="blue darken-1" depressed @click="cancel" class="warning">Cancel</v-btn>
                <v-btn color="blue darken-1" depressed @click="save" class="success">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon
          @click="editIntroBtn(item)"
          class="mr-2 edit"/>
        <v-icon
          @click="deleteIntro(item)"
          class="mr-2 delete"/>
      </template>

    </v-data-table>
  </div>
</template>

<script>
import ImageComponent from '../ImageComponent.vue';

export default {
  name: 'IntrosForAppsList',
  components: { ImageComponent },
  props: ['version', 'title', 'appCode'],

  data() {
    return {
      defaultIntroLocation: '/contacts/search',
      headers: [
        { text: 'Intro name', value: 'name', sortable: false },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      objects: [],
      newDialog: false,
      newSlides: [],
      files: [],
      newSlideFiles: [],
      edit: false,
      searchString: '',
      editedIntroSlides: [],
      editedIntroId: '',
      introTitle: '',
      introLocation: this.defaultIntroLocation,
      introActive: false,
    };
  },
  computed: {
    appId() {
      return this.$route.params.id;
    },
    getAppCode() {
      return this.appCode;
    },
    versionModules() {
      return this.objects;
    },
  },
  methods: {
    async setIntrosForApp() {
      await this.$http.get(`api/intros?app.code=${this.getAppCode}`).then((response) => {
        this.objects = response.data;
      });
    },

    save() {
      if (this.edit) {
        this.patchIntro();
      } else {
        this.postNewIntro().then(() => {
          this.patchIntro();
        });
      }
      this.newDialog = !this.newDialog;
    },

    cancel() {
      this.newDialog = !this.newDialog;
      this.setDefaultModelData();
    },

    async setDefaultModelData() {
      this.introLocation = this.defaultIntroLocation;
      this.introTitle = '';
      this.introActive = false;
      this.editedIntroSlides = [];
      this.newSlides = [];
      this.files = [];
      this.newSlideFiles = [];
      this.editedIntroId = '';
    },

    postNewIntro() {
      return new Promise((resolve) => {
        const data = {
          name: this.introTitle,
          location: this.introLocation,
          active: this.introActive,
          app: `/api/apps/${this.appId}`,
        };
        this.$http.post('api/intros', data).then((res) => {
          this.editedIntroId = res.data.id;
          this.newSlides.forEach((slide) => {
            // eslint-disable-next-line no-param-reassign
            slide.intro = `/api/intros/${this.editedIntroId}`;
          });
          resolve();
        });
      });
    },

    patchIntro() {
      if (this.files.length !== 0 || this.newSlideFiles.length !== 0) {
        this.postFiles().then(() => {
          this.internalPatchIntro();
        });
      } else {
        this.internalPatchIntro();
      }
    },

    internalPatchIntro() {
      const slides = this.editedIntroSlides.concat(this.newSlides);

      slides.forEach((slide) => {
        if ('image' in slide && slide.image === '') {
          // eslint-disable-next-line no-param-reassign
          delete slide.image;
        }
      });

      const data = {
        name: this.introTitle,
        location: this.introLocation,
        active: this.introActive,
        slides,
      };
      this.$http.patch(`api/intros/${this.editedIntroId}`, data, {
        headers: {
          'Content-Type': 'application/merge-patch+json',
        },
      }).then(() => {
        this.setDefaultModelData();
        this.setIntrosForApp();
      });
    },

    postFiles() {
      return new Promise((resolve) => {
        const promises = [];

        // process files for existing slides
        this.files.forEach((file, index) => {
          const formData = new FormData();
          formData.append('file', file);

          promises.push(
            this.$http.post('api/media_objects', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }).then((res) => {
              this.editedIntroSlides[index].image = `/api/media_objects/${res.data.id}`;
            }),
          );
        });

        // process files for new slides
        this.newSlideFiles.forEach((file, index) => {
          const formData = new FormData();
          formData.append('file', file);

          promises.push(
            this.$http.post('api/media_objects', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }).then((res) => {
              this.newSlides[index].image = `/api/media_objects/${res.data.id}`;
            }),
          );
        });

        Promise.all(promises).then(() => { resolve(); });
      });
    },

    newIntroBtn() {
      this.edit = false;
      this.editedIntroSlides = [];
    },

    editIntroBtn(item) {
      this.edit = true;
      this.newDialog = !this.newDialog;
      this.editedIntroId = item.id;
      this.editedIntroSlides = [];
      item.slides.forEach((slide) => {
        this.editedIntroSlides.push({
          id: `/api/slides/${slide.id}`,
          title: slide.title,
          description: slide.description,
          image: slide.image,
        });
      });
      this.introTitle = item.name;
      this.introLocation = item.location;
      this.introActive = item.active;
    },

    slideImageChanged(file, key) {
      this.files[key] = file;
    },

    newSlideImageChanged(file, key) {
      this.newSlideFiles[key] = file;
    },

    addNewSlide() {
      this.newSlides.push({
        title: '',
        description: '',
        intro: `/api/intros/${this.editedIntroId}`,
        image: '',
      });
    },

    deleteNewSlide(key) {
      if (this.newSlideFiles[key] !== undefined) {
        this.newSlideFiles.splice(key, 1);
      }
      this.newSlides.splice(key, 1);
    },

    deleteSlide(key) {
      this.editedIntroSlides.splice(key, 1);
    },

    deleteIntro(item) {
      this.$http.delete(`api/intros/${item.id}`).then(() => {
        this.setIntrosForApp();
      });
    },
  },

  async created() {
    await this.setIntrosForApp();
    await this.setDefaultModelData();
  },
};
</script>

<style scoped>

</style>
